import { useCallback, useState } from "react";

// Incapsula il pattern ripetuto "setBusy → try await → catch console.error+alert
// → finally setBusy(false)" delle azioni asincrone (mutation, export, ecc.).
//
// `activeKey` traccia QUALE azione è in corso: per i casi booleani vale `true`
// mentre l'azione gira; passando una `key` (es. l'id di uno stage/girone) si può
// distinguere su quale elemento è in corso l'operazione, sostituendo i vari
// `generatingStageId === id`.

interface RunOptions<K> {
  errorMessage?: string;
  key?: K;
}

export function useAsyncAction<K = boolean>() {
  const [activeKey, setActiveKey] = useState<K | null>(null);

  const run = useCallback(
    async <T>(action: () => Promise<T>, options: RunOptions<K> = {}): Promise<T | undefined> => {
      const { errorMessage = "Si è verificato un errore. Riprova.", key } = options;
      setActiveKey(key ?? (true as unknown as K));
      try {
        return await action();
      } catch (error) {
        console.error(error);
        alert(errorMessage);
        return undefined;
      } finally {
        setActiveKey(null);
      }
    },
    []
  );

  return { activeKey, isPending: activeKey !== null, run };
}
